import { fetcher } from "@/shared/lib/fetcher.client";
import { CustomAttributesResponse } from "@/shared/types/askedAttributes.types";

export const customAttributesService = {
  async getAskedAttributes(): Promise<CustomAttributesResponse> {
    const response = await fetcher<CustomAttributesResponse>("/employees/asked_attributes");
    return response.data;
  },
};
